import { useTranslation } from "react-i18next";

const NBSP = " ";

// Savings are shown as an amount ("Save 100 ₾") rather than a percentage:
// above ~100 ₾ an absolute discount reads as the bigger deal.
// Old and new price share one size: a sale price drawn bigger than the old
// one makes the deal feel smaller (Coulter & Coulter 2005).
const SIZES = {
  sm: {
    layout: "flex-wrap items-center gap-x-2 gap-y-1",
    price: "text-lg",
    // Same green as the discount line in the cart and order summaries.
    save: "text-sm text-green-700",
  },
  // Cards are 200-260px wide, too narrow to keep the label on the price row
  // consistently, so it always gets its own line there. The price is the same
  // size as the cards' titles (Home/Item.jsx), a step smaller on phones.
  md: {
    layout: "flex-col items-start gap-1",
    price: "text-lg min-[576px]:text-xl",
    save: "text-sm px-2 py-0.5 rounded bg-green-700 text-white",
  },
  lg: {
    layout: "flex-wrap items-center gap-x-2 gap-y-1",
    price: "text-2xl",
    save: "text-base px-2 py-0.5 rounded bg-green-700 text-white",
  },
};

export default function Price({ product, size = "md", className = "" }) {
  const { t } = useTranslation();
  const styles = SIZES[size];
  const savings = Math.round((product.oldPrice - product.price) * 100) / 100;

  return (
    <p className={`flex ${styles.layout} ${className}`}>
      <span className="flex items-center gap-x-2">
        {/* Old price first: with the larger number on the left the discount is
            easier to subtract and feels bigger (Biswas et al. 2013). */}
        {savings > 0 && (
          <s className={`text-[#626468] decoration-1 ${styles.price}`}>
            {product.oldPrice}
            {NBSP}₾
          </s>
        )}
        {/* Regular weight on purpose: next to the bold savings amount, a lighter
            price reads as smaller (size congruity, Coulter & Coulter 2005). */}
        <span className={styles.price}>
          {product.price}
          {NBSP}₾
        </span>
      </span>
      {savings > 0 && (
        <span className={`whitespace-nowrap leading-snug ${styles.save}`}>
          {t("save")}{" "}
          <span className="font-bold">
            {savings}
            {NBSP}₾
          </span>
        </span>
      )}
    </p>
  );
}
